import { configureStore } from '@reduxjs/toolkit';
import { userSlice, userSelector } from '../features/User/UserSlice';
export default configureStore({
  reducer: {
      user: userSlice.reducer,

  },
});